import React, { useState } from 'react';
type SmartImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  wrapperClassName?: string;
  sizes?: string;
  priority?: boolean;
};

/**
 * Imagen optimizada: reserva el espacio con width/height, descarga diferida
 * fuera de pantalla, decodificación asíncrona y aparición suave al cargar.
 */
export function SmartImage({
  src,
  alt,
  width,
  height,
  className = '',
  wrapperClassName = '',
  sizes,
  priority = false
}: SmartImageProps) {
  const [loaded, setLoaded] = useState(false);
  return <span className={`block overflow-hidden bg-cream-200 ${wrapperClassName}`} data-id="element-286" data-mp="16sr4b5s2cny7">
      <img src={src} alt={alt} width={width} height={height} sizes={sizes} loading={priority ? 'eager' : 'lazy'} decoding={priority ? 'sync' : 'async'} {...{
      fetchpriority: priority ? 'high' : 'low'
    } as Record<string, string>} onLoad={() => setLoaded(true)} className={`transition-opacity duration-200 ease-out ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`} data-id="element-287" data-mp="1lkt1uj6nv4v2" />
    </span>;
}